module.exports = __webpack_public_path__ + "img/download.6bbe63fa.svg";